import { MealPlanType } from './MealPlanType'
import { translate } from 'rhg-vue-common'

export default class MealPlan {
  static fromJSON(json) {
    return new MealPlan({
      stayId: json.identifier,
      code: json.mealPlanDto.code,
      description: json.mealPlanDto.description,
      index: json.mealPlanDto.index,
      price: json.mealPlanPriceIncrement
    })
  }

  constructor({ stayId, code, index, price }) {
    this.stayId = stayId
    this.code = code
    this.description = translate(this.getMealPlan(code).text)
    this.index = index
    this.classIcon = this.getMealPlan(code).classIcon
    this.price = price
  }

  getMealPlan = (mealPlan) => {
    const result = MealPlanType.filter((item) => {
      return item.key === mealPlan
    })
    return result.length && result[0]
  }
}
